import React from 'react';
import { settings, purchaseDemand } from '../../../../models/entities/purchaseDemand/purchaseDemand';
import { localizationSelectors } from '../../../../state/ducks/localization/selectors';
import { purchaseDemandsSelectors } from '../../../../state/ducks/purchaseDemands/selectors';
import { RootState } from '../../../../state/store/store';
import { connect } from 'react-redux';
import { singlePurchaseDemandSelectors } from '../../../../state/ducks/singlePurchaseDemand/selectors';
import { document } from '../../../../models/entities/common_subentities/document';
import { userSelectors } from '../../../../state/ducks/user/selectors';
import MultipleDocumentFormConnected, { formMode } from '../../commonSubEntities/documents/DocumentForm/MultipleDocumentFormConnected';

type Props = {
    purchaseDemand?: purchaseDemand;
    mode: formMode;
    localizations?: any;
    settings?: settings;
    openedFromModal?: {
        setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    };
    confirmation?: { setConfirm: React.Dispatch<React.SetStateAction<boolean>> };
    createMultiplePurchaseDemandDocument: (purchaseDemandNumber: string, documents: Array<document>) => void;
    showLoader?: boolean;
};

const PurchaseDemandMultipleDocumentFormConnected = ({
    purchaseDemand,
    localizations,
    mode,
    settings,
    openedFromModal,
    confirmation,
    createMultiplePurchaseDemandDocument,
    showLoader
}: Props) => {
    return (
        <MultipleDocumentFormConnected<purchaseDemand, settings>
            entity={purchaseDemand}
            mode={mode}
            localizations={localizations}
            settings={settings}
            openedFromModal={openedFromModal}
            confirmation={confirmation}
            createMultipleDocument={createMultiplePurchaseDemandDocument}
            showLoader={showLoader}
        />
    );
};

const mapStateToProps = (state: RootState) => ({
    localizations: localizationSelectors.singlePurchaseDemandPage(state),
    settings: purchaseDemandsSelectors.settingsByLanguage(state),
    purchaseDemand: singlePurchaseDemandSelectors.purchaseDemand(state),
    showLoader: state.loading.effects.purchaseDemands.createMultiplePurchaseDemandDocument,
    userInfo: userSelectors.userInfo(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    createMultiplePurchaseDemandDocument: (purchaseDemandNumber: string, documents: Array<document>) =>
        dispatch.purchaseDemands.createMultiplePurchaseDemandDocument({ purchaseDemandNumber, documents }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseDemandMultipleDocumentFormConnected);
